var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8127 19.9671C20.6556 19.9671 18.9005 21.7841 18.9005 24.0197C18.9005 26.2553 20.6556 28.0723 22.8127 28.0723C24.9699 28.0723 26.7235 26.2553 26.7235 24.0197C26.7235 21.7841 24.9699 19.9671 22.8127 19.9671Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9456 18.2417C29.1356 18.2417 28.4748 17.5608 28.4748 16.7253C28.4748 15.8867 29.1356 15.2059 29.9456 15.2059C30.7556 15.2059 31.4149 15.8867 31.4149 16.7253C31.4149 17.5608 30.7556 18.2417 29.9456 18.2417ZM22.8119 30.2832C19.4809 30.2832 16.7696 27.4743 16.7696 24.02C16.7696 20.5657 19.4809 17.7568 22.8119 17.7568C26.1443 17.7568 28.8542 20.5657 28.8542 24.02C28.8542 27.4743 26.1443 30.2832 22.8119 30.2832ZM29.0261 9.53369H17.0396C12.5505 9.53369 9.53357 12.8082 9.53357 17.6832V29.3842C9.53357 34.2577 12.5505 37.5337 17.0396 37.5337H29.0247C33.5153 37.5337 36.5336 34.2577 36.5336 29.3842V17.6832C36.5336 12.8082 33.5167 9.53369 29.0261 9.53369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3db8207ce67fd94700629b0f12775ca4.svg";
export { ForwardRef as ReactComponent };